export default "__VITE_ASSET__CNEqNENB__"